import { CategoryPageData } from '@jbhi-fi/components/src/hooks/useContentfulHelpAndSupport/useContentfulHelpAndSupport';
import { ContentfulSupportArticle, ContentfulSupportCategory } from '@jbhi-fi/apis/src/contentful/types';
import { SupportCategoryProps } from '../../HelpAndSupport/SupportCategory/SupportCategory';

export abstract class SupportCategoryTransformer {
  static toSupportCategoryProps = ({
    title,
    subCategories,
    nestedSubCategories,
    articles,
  }: CategoryPageData): SupportCategoryProps => {
    return {
      title,
      sections: subCategories.map((subCategory: ContentfulSupportCategory) => ({
        title: subCategory?.fields?.heading || '',
        url: subCategory.fields?.urlSlug || '',
        nestedSubCategories: nestedSubCategories
          .filter((nested: ContentfulSupportCategory) => nested?.fields?.parentCategory?.sys?.id === subCategory.sys.id)
          .map((nested: ContentfulSupportCategory) => ({
            title: nested?.fields?.heading || '',
            url: nested?.fields?.urlSlug || '',
          })),
        articles: articles
          .filter((article: ContentfulSupportArticle) => {
            return article?.fields?.supportCategory?.sys?.id === subCategory.sys.id;
          })
          .map((article: ContentfulSupportArticle) => ({
            title: article?.fields?.heading || '',
            url: article?.fields?.urlSlug || '',
          })),
      })),
    };
  };
}
